// removed by extract-text-webpack-plugin
module.exports = {"search-status":"search-status___3K4mv","no-match":"no-match___1q6FH","space":"space___2NO7v","match":"match___PaKCt","results-for":"results-for___3ik-J","searching-for":"searching-for___3uOf_","search":"search___3hblH","throbber-wrapper":"throbber-wrapper___UNLdM","throbber":"throbber___-OiqL","clear":"clear___2xtP9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/SearchStatus.scss
// module id = WH74
// module chunks = 46